import { observer } from 'mobx-react-lite';
import { MouseEvent } from 'react';

import Icon from '~/components/Icon/Icon';
import { useProductCard } from '~/components/ProductCard/hooks/useProductCard';
import { useNotifyMe } from '~/hooks/useNotifyMe';
import { Product } from '~/stores/CategoriesStore';

import Counter from './Counter';
import styles from './FavoriteAddToCartButton.module.scss';

const FavoriteAddToCartButton = ({
  product,
  onClose,
}: {
  product: Product;
  onClose: () => void;
}) => {
  const {
    limit,
    cartItemsCount,
    changeCount,
    currentItem,
    productHasManyVariants,
    isBundle,
    openSelectSKUModal,
  } = useProductCard(product, product.offers[0]);

  const { notifyMeOnClick, notifyMeIconV2 } = useNotifyMe(
    product.offers[0]?.productId ?? product.id ?? 0,
    currentItem.sku ?? '',
    isBundle,
    true,
  );

  const addButtonHandler = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (productHasManyVariants && !isBundle) {
      openSelectSKUModal();
      onClose();
      return;
    }

    changeCount(cartItemsCount + 1, 'add');
  };

  const handleClickNotifyMe = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    notifyMeOnClick();
  };

  if (limit <= 0) {
    return (
      <div
        data-button="add-to-cart"
        className={styles.addToCardBtn}
        role="button"
        tabIndex={-1}
        onClick={handleClickNotifyMe}
      >
        <Icon type={notifyMeIconV2} size={24} />
      </div>
    );
  }
  return (
    <>
      {cartItemsCount > 0 ? (
        <Counter count={cartItemsCount} onClick={changeCount} limit={limit} />
      ) : (
        <div
          data-button="add-to-cart"
          className={styles.addToCardBtn}
          role="button"
          tabIndex={-1}
          onClick={addButtonHandler}
        >
          <Icon type="plus-alt" size={24} />
        </div>
      )}
    </>
  );
};

export default observer(FavoriteAddToCartButton);
